<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="chapter">
<div class="bodymatter" epub:type="bodymatter">
<section epub:type="division" id="toc">
<h1 class="toc"><span class="red"><strong>CONTENTS</strong></span></h1>
<div class="toc_chap"><a class="hlink" href="#/Text/frw"><span class="red1">Foreword</span></a></div>
<div class="toc_chap"><a class="hlink" href="#/Text/itr"><span class="red1">Introduction</span></a></div>
<div class="toc_chap"><a class="hlink" href="#/Text/c01#c01a"><span class="red1">Chapter 1:</span> <span class="red">The Power of Super Seeds</span></a></div>
<div class="toc_chap"><span class="hlink" href="#/Text/c02#c02a" title="Link target outside of Sample"><span class="red1">Chapter 2:</span> <span class="red">Basic Super Seed Recipes and Preparations</span></span></div>
<div class="toc_chap"><span class="hlink" href="#/Text/c03#c03a" title="Link target outside of Sample"><span class="red1">Chapter 3:</span> <span class="red">Breakfasts</span></span></div>
<div class="toc_chap"><span class="hlink" href="#/Text/c04#c04a" title="Link target outside of Sample"><span class="red1">Chapter 4:</span> <span class="red">Soups and Salads</span></span></div>
<div class="toc_chap"><span class="hlink" href="#/Text/c05#c05a" title="Link target outside of Sample"><span class="red1">Chapter 5:</span> <span class="red">Entrees</span></span></div>
<div class="toc_chap"><span class="hlink" href="#/Text/c06#c06a" title="Link target outside of Sample"><span class="red1">Chapter 6:</span> <span class="red">Baked Goods</span></span></div>
<div class="toc_chap"><span class="hlink" href="#/Text/c07#c07a" title="Link target outside of Sample"><span class="red1">Chapter 7:</span> <span class="red">Desserts</span></span></div>
<div class="toc_chap"><span class="hlink" href="#/Text/bm#bma" title="Link target outside of Sample"><span class="red1">Super Seed Extras</span></span></div>
<div class="toc_chap1"><span class="hlink" href="#/Text/bm1" title="Link target outside of Sample"><span class="red1">Conversion Charts</span></span></div>
<div class="toc_chap1"><span class="hlink" href="#/Text/bm3" title="Link target outside of Sample"><span class="red1">Frequently Asked Questions</span></span></div>
<div class="toc_chap1"><span class="hlink" href="#/Text/res" title="Link target outside of Sample"><span class="red1">Resources</span></span></div>
<div class="toc_chap1"><span class="hlink" href="#/Text/ata" title="Link target outside of Sample"><span class="red1">About the Author</span></span></div>
<div class="toc_chap1"><span class="hlink" href="#/Text/ack" title="Link target outside of Sample"><span class="red1">Acknowledgments</span></span></div>
<div class="toc_chap1"><span class="hlink" href="#/Text/crd" title="Link target outside of Sample"><span class="red1">Credits</span></span></div>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2d613e6d